import * as CubeTree from '../../../cubeTree/index';
import { __size__, __has__, __getAll__, __getWrapRect__, __getByType__, __allType__ } from './db';

// 长度计算
export function size(): number {
    return __size__();
}

// 是否存在
export function has(cubeId: string): boolean {
    return __has__(cubeId);
}

export function getAll(): Array<CubeId> {
    return __getAll__();
}

export function getSelectWrapRect(): LogicCoordinate {
    return __getWrapRect__();
}

export function isEmpty(): boolean {
    return __size__() === 0;
}

export function getSelectedByType(cubeType: CubeType): Array<CubeId> {
    return __getByType__(cubeType);
}

export function allSelectedType(): Array<CubeType> {
    return __allType__();
}
